// src/components/ngo/CapacityHero.jsx
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CapacityHero = () => {
  return (
    <section className="relative h-[80vh] md:h-[70vh] w-full overflow-hidden bg-gray-900 text-white font-body">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover brightness-[0.4]"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/videos/ngo-training.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center items-start h-full max-w-6xl mx-auto px-6">
        <motion.h1
          className="text-3xl md:text-5xl font-heading font-bold mb-4 text-white"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          NGO Capacity Building Program
        </motion.h1>

        <motion.p
          className="text-lg md:text-xl text-gray-200 max-w-2xl mb-2"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          Empowering <span className="text-secondary font-semibold">Social Organizations</span> for Long-Term Impact through <span className="text-primary font-semibold">strategy</span>, <span className="text-secondary font-semibold">training</span>, and <span className="text-primary font-semibold">mentorship</span>.
        </motion.p>

        <motion.div
          className="mt-6"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <Link
            to="/contact"
            className="inline-block bg-primary hover:bg-secondary transition text-white font-semibold px-6 py-3 rounded-full shadow-lg text-base md:text-lg"
          >
            Apply Now →
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CapacityHero;
